import React, { useState, useEffect } from 'react';
import { getUserProvider} from '../../../actions/auth.js';
import MatchesRugbyCSV from './MatchesRugbyCSV';
import MatchesBasketCSV from './MatchesBasketCSV';

const MatchesCSV = () => {
  const [sportType, setSportType] = useState('');
  const [template, setTemplate] = useState('');
  const [provider, setProvider] = useState('');
  const [isInputValid, setIsInputValid] = useState(false);
  //const [isDisabled, setIsDisabled] = useState(false);

   // Effet secondaire pour initialiser le provider après le rendu initial
   useEffect(() => {
    setProvider(getUserProvider());
  }, []); 

  // Fonction pour gérer le changement du type de sport
  const handleSportTypeChange = (selectedSport) => {
    setSportType(selectedSport);
    setTemplate('');
    setProvider('');
    handleValidation()
  };

  // Fonction pour gérer le changement du template
  const handleTemplateChange = (selectedTemplate) => {
    setTemplate(selectedTemplate);
    setProvider('');
    handleValidation()
  };

  // Fonction pour gérer le changement du provider
  const handleProviderChange = (e) => {
    setProvider(e.target.value);
    handleValidation()
  }; 

  // Fonction pour valider la saisie
  const handleValidation = () => {
    if ((template === 'Données DSAS' && provider.trim() !== '') || template === 'Données fournisseur') {
      setIsInputValid(true);
    }
  };

  // Fonction pour rendre le composant approprié en fonction des choix
  const renderMatchesComponent = () => {
    
      if (sportType === 'rugby' && template === 'Données fournisseur') {
        return <MatchesRugbyCSV />;
      } else if (sportType && template === 'Données DSAS' && provider && isInputValid) {
        return <MatchesBasketCSV importOption='dropzone' provider={provider} discipline={sportType} />;
      }
    
    return null;
  };

  return (
    <div style={{
      paddingTop: '15px',
      paddingBottom: '15px'
    }}>
      <div style={{
        display:'flex',
        paddingTop: '15px',
        paddingBottom: '15px'
      }}>
        {/* Sélection du type de sport */}
        <select
          style={{
            width: '33%',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc'
          }}
          onChange={(e) => handleSportTypeChange(e.target.value)}
          //disabled={isDisabled} 
        >
          <option value="">Sélectionnez le type de sport</option>
          <option value="rugby">Rugby</option>
          <option value="basket">Basket</option>
          <option value="soccer">Football</option>
          <option value="handball">Handball</option>
        </select>

        {/* Sélection du template */}
        {sportType && (
          <>
            <select
              style={{
                width: '33%',
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid #ccc'
              }}
              onChange={(e) => handleTemplateChange(e.target.value)}
              value={template}
              //disabled={isDisabled} 
            >
              <option value="">Sélectionnez le template</option>
              {sportType === 'rugby' && <option value="Données fournisseur">Données fournisseur</option>}
              {sportType && <option value="Données DSAS">Données DSAS</option>}
            </select>

             {/* Champ de saisie pour le provider */}
            {template === 'Données DSAS' && (
              <>
              <div style={{ width: '30%', display: 'flex'}}>
              <input
                  type="text"
                  style={{ padding: '11px', borderRadius: '5px', border: '1px solid #ccc', width: '100%'}}
                  placeholder="Entrez le provider"
                  value={provider}
                  onChange={handleProviderChange}
                  //disabled={isDisabled} 
                />
              </div>
              </>
            )}
          </>
        )}
      </div>
      {/* Rendre le composant approprié */}
      {renderMatchesComponent()}
    </div>
  );
};

export default MatchesCSV;